<template>
  <div>
    <Row type="flex" justify="space-between" :gutter="15">
      <i-col span="4">
        <div class="box no-border-radius ">
          <Spin v-if="loadingStatus" fix />
          <div class="box-header with-border">
            <h3 class="box-title">
              <i class="fas fa-code-branch" style="padding-right: 10px" />菜单树状视图
            </h3>
          </div>
          <div class="box-body tree-body" :style="{height: treeHeight + 63 + 'px'}">
            <Tree :data="treeData" style="margin-left: 15px" />
          </div>
        </div>
      </i-col>
      <i-col span="20">
        <div class="box no-border-radius ">
          <div class="box-header with-border">
            <h3 class="box-title">
              <i class="fas fa-bars" style="padding-right: 10px" />菜单列表
            </h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool">
                <i class="fas fa-plus" />
              </button>
            </div>
          </div>
          <div class="box-body">
            <TableWrapper
              :border="false"
              :pager="true"
              :init-page-size="100"
              :url="url"
              :columns="columns"
              :offset-height="offsetHeight"
              :show-add="true"
              :mod-count="modCount"
              @on-ready="onReady"
              @on-add="showFormModalDialog"
            />
          </div>
        </div>
      </i-col>
    </Row>
    <MenuFormDialog
      :id="entityId"
      :visible="modalForm"
      :width="550"
      :action="url"
      @on-close="onModalClose"
    />
    <MenuFunctionDialog
      :id="entityId"
      caption="菜单功能"
      :current-menu="currentMenu"
      :visible="modalFunction"
      :width="980"
      :action="url"
      @on-close="onFunctionModalClose"
    />
  </div>
</template>

<script>
import MenuFormDialog from './dialog/menu-dialog'
import MenuFunctionDialog from './dialog/menu-function'
import TableWrapper from '@/components/table-wrapper'
import request from '@/utils/request'
export default {
  name: 'SystemMenu',
  components: {
    TableWrapper, MenuFormDialog, MenuFunctionDialog
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/menu', // this.$config.apiMockContext + '/mockdata1/menu',
      offsetHeight: 240,
      loadingStatus: true,
      treeData: [],
      modalForm: false,
      modalFunction: false,
      entityId: 0,
      modCount: 0,
      treeHeight: 300,
      currentMenu: ''
    }
  },
  computed: {
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '父级菜单', align: 'left', key: 'parent', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.parent || '---')
          }
        },
        { title: '菜单名称', align: 'left', key: 'label', sortable: true },
        { title: '菜单图标', align: 'center', key: 'icon', sortable: true,
          render: (h, params) => {
            return h('i', {
              class: ['fas', params.row.icon]
            })
          }
        },
        // { title: '路由标识名', align: 'center', key: 'name', sortable: true },
        { title: '资源路径', align: 'left', width: 150, ellipsis: true, tooltip: true, key: 'path', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.path ? params.row.path : '--')
          }
        },
        { title: '菜单描述', align: 'left', key: 'description', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.description || '---')
          }
        },
        { title: '模块名称', align: 'left', key: 'module', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.module || '---')
          }
        },
        { title: '状态', align: 'center', key: 'visible', sortable: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 1 ? 'green' : '#ccc' }
            }, params.row.status === 1 ? '可见' : '隐藏')
          }
        },
        { title: '操作', align: 'center', width: 200,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: {
                  color: params.row.id && params.row.path ? '#126D91' : '#ccc',
                  marginRight: '10px',
                  cursor: params.row.id && params.row.path ? 'pointer' : 'not-allowed'
                },
                on: {
                  click: () => {
                    if (params.row.id && params.row.path) {
                      this.showFunctionModalDialog(params.row.id, params.row.label)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-cogs': true, 'cell-icon-link': true }}),
                h('span', {}, '配置')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: { color: '#126D91' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.label)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ])
            ])
          }
        }
      ]
    }
  },
  mounted() {
    this.treeHeight = document.documentElement.clientHeight - this.offsetHeight
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    onResize(event) {
      this.treeHeight = document.documentElement.clientHeight - this.offsetHeight
    },
    showFunctionModalDialog: function(id, label = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalFunction = true
      this.currentMenu = label
    },
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    renderContent(h, { root, node, data }) {
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    onFunctionModalClose: function(changed) {
      this.entityId = 0
      this.modalFunction = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    showDelModalDialog: function(id, label) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除菜单信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, label)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '菜单 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '菜单 `' + label + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    formatRouteTreeNodes: function(routes) {
      const treeNodes = []
      for (const route of routes) {
        const node = {
          label: route.label,
          icon: route.icon,
          expand: true,
          children: [],
          render: (h, { root, node, data }) => {
            return h('span', {}, [
              h('i', { class: ['fas', data.icon, 'tree-icon-color'], style: { marginRight: '5px' }}),
              h('span', data.label)
            ])
          }
        }
        if (route.parentId && route.parentId > 0) {
          route.parentId = 0
          node.children = this.formatRouteTreeNodes([route])
        }
        treeNodes.push(node)
      }
      return treeNodes
    },
    onReady: function(data) {
      // getRouterNameByPath()
      const parents = []
      const leafs = []
      // const tree = [{ title: '系统菜单', expand: true, children: [] }]
      this.loadingStatus = false
      if (data && data.length > 0) {
        for (const item of data) {
          const options = {
            label: item.label,
            icon: item.icon,
            expand: true,
            children: [],
            render: (h, { root, node, data }) => {
              return h('span', {}, [
                h('i', { class: ['fas', data.icon], style: { marginRight: '5px', color: '#19be6b' }}),
                h('span', data.label)
              ])
            }
          }
          if (!item.parent) {
            parents.push(options)
          } else {
            leafs.push({ parent: item.parent, options: options })
          }
        }
      }
      if (leafs.length > 0) {
        for (const parent of parents) {
          for (const leaf of leafs) {
            if (leaf.parent === parent.label) {
              parent.children.push(leaf.options)
            }
          }
        }
      }
      this.treeData = parents
    }
  }
}
</script>

<style scoped>
.box-body {
  padding: 0px !important;
}
.tree-body {
  overflow: auto;
  padding-bottom: 15px !important;
}
</style>

